import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from "@/components/ui/dialog";
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger
} from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Info } from 'lucide-react';

interface Props {
    isEnabled: boolean;
    config?: any;
}

const GoogleMapsDialog: React.FC<Props> = ({ isEnabled, config }) => {

    const [webKey, setWebKey] = useState('');
    const [mobileKey, setMobileKey] = useState('');

    const [open, setOpen] = useState(false);

    useEffect(() => {
        const web = config?.find((item: { type: string; }) => item.type === 'WEB');
        const mobile = config?.find((item: { type: string; }) => item.type === 'MOBILE');

        if (web) setWebKey(web.value);
        if (mobile) setMobileKey(mobile.value);
    }, [config]);

    const handleSave = () => {
        console.log('Saving config:', { webKey, mobileKey });
        setOpen(false);
        // You can trigger a mutation or API request here
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                {isEnabled ? (
                    <Button variant="outline" className="flex items-center gap-2">
                        <Info size={16} /> Details
                    </Button>
                ) : (
                    <Button variant="outline">Integrate</Button>
                )}
            </DialogTrigger>
            <DialogContent className="sm:max-w-xl">
                <DialogHeader>
                    <DialogTitle>Google Maps Integration</DialogTitle>
                </DialogHeader>
                <Tabs defaultValue="WEB">
                    <TabsList className="mb-4">
                        <TabsTrigger value="WEB">Web</TabsTrigger>
                        <TabsTrigger value="MOBILE">Mobile</TabsTrigger>
                    </TabsList>
                    <TabsContent value="WEB">
                        <p className="text-sm text-gray-600 mb-2">Enter your Web API Key:</p>
                        <Input
                            placeholder="Enter Web API Key"
                            value={webKey}
                            onChange={(e) => setWebKey(e.target.value)}
                            className="mb-4"
                        />
                    </TabsContent>
                    <TabsContent value="MOBILE">
                        <p className="text-sm text-gray-600 mb-2">Enter your Mobile API Key:</p>
                        <Input
                            placeholder="Enter Mobile API Key"
                            value={mobileKey}
                            onChange={(e) => setMobileKey(e.target.value)}
                            className="mb-4"
                        />
                    </TabsContent>
                </Tabs>
                <div className="flex justify-end pt-2">
                    <Button onClick={handleSave}>Save Configuration</Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default GoogleMapsDialog;
